/*
(required) inputValue = setState value
(required) setInputValue = setState function
(required) keyDown = any function to be run on Enter click
(required) theme = "blue", "blue-dark", "blue-light", "gray" etc... NOTE: Need to extend the applyTheme() function
if trying to render a color that isn't in it. dicatates input:focus border color
(optional) label = String to be shown in label
(optional) labelBold = default false, true
(optional) placeholder = String to be shown in placeholder
(optional) size = default "default", expanded
(optional) required = default false, true
(optional) searchIcon = default false, true
(optional) twcss = "text-sm md:text-base"

<BidInput
    inputValue={searchInput}
    setInputValue={setSearchInput}
    theme="blue"
    label="Billing Address"
    labelBold
    placeholder="Address"
    size="expanded"
    required={true}
    searchIcon={true}
    twcss="text-sm"
/>
*/
import { useEffect, useState } from 'react'
import useDebounce from 'hooks/useDebounce'
import BidSearchIcon from '../BidSearchIcon/BidSearchIcon'

export default function BidInput({
  inputValue,
  setInputValue,
  bindInputValue = false,
  keyDown = () => {},
  theme,
  label,
  labelBold,
  placeholder,
  size,
  required,
  searchIcon,
  disabled = false,
  type = 'text',
  py = '2',
  w = 'full',
  iconTop = '3',
  debounceTimer = 100,
  twcss,
  RightIcon = BidSearchIcon,
  onClickRightIcon = null,
}: any) {
  const [value, setValue] = useState<string>(inputValue || '')
  const debouncedValue = useDebounce(value, debounceTimer)

  useEffect(() => {
    if (bindInputValue && value !== inputValue) {
      setValue(inputValue)
    }
  }, [inputValue])

  useEffect(() => {
    if (debouncedValue !== inputValue) {
      setInputValue(debouncedValue)
    }
  }, [debouncedValue])

  const applyTheme = () => {
    let focusColor = ''

    switch (theme) {
      case 'blue':
        focusColor = 'focus:border-bidfta-blue'
        break
      case 'blue-light':
        focusColor = 'focus:border-bidfta-blue-light'
        break
      case 'blue-dark':
        focusColor = 'focus:border-bidfta-blue-dark'
        break
      default:
        break
    }
    return focusColor
  }

  return (
    <label
      htmlFor={label}
      className={`relative block ${labelBold ? 'font-bold' : ''} ${
        twcss || ''
      }`}
    >
      {label || ''}
      {required && label && <span className="text-red relative left-1">*</span>}
      <input
        type={type}
        name={label}
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && keyDown(e)}
        placeholder={placeholder || ''}
        required={required}
        className={`w-${w} leading-5 rounded-md border px-4 ${
          searchIcon ? 'pr-8' : ''
        } ${disabled ? 'bg-gray-200' : 'bg-white'}
                placeholder-bidfta-gray-dark text-base
                border-bidfta-gray-fieldborder focus:outline-none ${applyTheme()}
                ${size === 'expanded' ? 'py-4' : `py-${py}`}
                `}
      />
      {searchIcon && (
        <span
          className={`absolute right-2.5 cursor-pointer ${
            size === 'expanded' ? 'top-5' : `top-${iconTop}`
          }`}
          role="button"
          onClick={onClickRightIcon ? onClickRightIcon : keyDown}
          onKeyDown={(e: any) => e.key === 'Enter' && keyDown(e)}
          tabIndex={0}
        >
          <RightIcon />
        </span>
      )}
    </label>
  )
}
